
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91slug_93saOIxIFMGHXnmHQoD_g_aDWuF17P58DBuvovIMpC8uUMeta } from "/app/apps/web/app/pages/blog/[slug].vue?macro=true";
import { default as addinK5YZdkrxglfYUu0_oqlTIrTy10WK_bo1iPcMnpArVa0Meta } from "/app/apps/web/app/pages/addin.vue?macro=true";
import { default as _91id_93yKJykRnWDg2JGHonGZIjpDA_KsGpnNmCWPOsHzfIoM0Meta } from "/app/apps/web/app/pages/app/briefs/case/[id].vue?macro=true";
import { default as _91id_93UnnW8Lcf_Na3ShShiOzcSRGg29lxwecdGUuGBCIfOhYMeta } from "/app/apps/web/app/pages/app/briefs/parties/[id].vue?macro=true";
import { default as _91id_93_UtH3CXDVcISWoLefzQZwMMkTyhNJjRLDC4JVI9_lQEMeta } from "/app/apps/web/app/pages/app/laws/id/[id].vue?macro=true";
import { default as newvuESonCdFvPpkhfvDXh7zfnz6Fb__o_at9aGYEclSvoMeta } from "/app/apps/web/app/pages/app/cases/new.vue?macro=true";
import { default as newHx3nthgtBjkzYmyCser6lv9vcOHVgzO572W0uYLwI_wMeta } from "/app/apps/web/app/pages/app/clients/new.vue?macro=true";
import { default as parties4794QlqSkX8FlJu379KDZQE4doPxj7EXUFGfobQhyd8Meta } from "/app/apps/web/app/pages/app/clients/parties.vue?macro=true";
import { default as trashm4m9Y4Hdn3KfYSQ8a1L_CLemvl0rEH_1dJmCr1ZYKaEMeta } from "/app/apps/web/app/pages/app/docs/trash.vue?macro=true";
import { default as newU_7GzbNrNL8lpd2Dwd4IPTqnlWSnXfTE_p2AamMwItcMeta } from "/app/apps/web/app/pages/app/cases/[id]/notes/new.vue?macro=true";
import { default as newOqsK12cxDy12OvdvQOFQw_16JEmepdsh_QTnTQC_kpEMeta } from "/app/apps/web/app/pages/app/cases/[id]/tasks/new.vue?macro=true";
import { default as _91workflowId_93v_j7e9EOte3fIuFWS3zDNB62QlvW5sQympydyTN9_BUMeta } from "/app/apps/web/app/pages/app/cases/[id]/workflow/[workflowId].vue?macro=true";
import { default as _91workflowId_939Kw2MLS14ZnHV_sMtIF0ADi0_UMKiOvRIu0fafpdXEMMeta } from "/app/apps/web/app/pages/app/clients/[id]/workflow/[workflowId].vue?macro=true";
import { default as documentsXfQ2IApbDi0F83czgLix5XlJlr5Ja2kAs7MUK32sKFgMeta } from "/app/apps/web/app/pages/app/cases/[id]/documents.vue?macro=true";
import { default as personeriaRt_6xEF5zT7pHnHDpsTxwuzgnXqtSDpbB4ZEb_9wb_4Meta } from "/app/apps/web/app/pages/app/cases/[id]/personeria.vue?macro=true";
import { default as personeriaKOjNog9CdxAGi9U6agrVpjL7CsXoNqXaYo3_dF93JgEMeta } from "/app/apps/web/app/pages/app/clients/[id]/personeria.vue?macro=true";
import { default as _91type_93CaPNbGPdJRTMhfJ5Ojb82NbVIT8sXPZKEmncnDPkSuoMeta } from "/app/apps/web/app/pages/app/briefs/[type].vue?macro=true";
import { default as _91id_93XYpY3eUiUfTr1be_S5tmRmE9rSs8brlnPrM6BPUF7g8Meta } from "/app/apps/web/app/pages/app/c/[id].vue?macro=true";
import { default as indexxhDrbIxkrRJb3l8K27ovlY_3D2vGYQXXZMWedTMN2iwMeta } from "/app/apps/web/app/pages/app/cases/[id]/index.vue?macro=true";
import { default as index9USJhGFgG0tDy7dbSrnRQLPnwvWl_8cnch6t6_S3q7EMeta } from "/app/apps/web/app/pages/app/clients/[id]/index.vue?macro=true";
import { default as _91id_93gmLsnNmwJXWCspsl9H4bOgk4ew4chW3WQHEOMdQRf60Meta } from "/app/apps/web/app/pages/app/contract-review/[id].vue?macro=true";
import { default as _91id_93jQ9LWN1sE8jB228k_lqMd44vz4jxfRNrENpXKkMEDUAMeta } from "/app/apps/web/app/pages/app/docs/[id].vue?macro=true";
import { default as _91id_93l8nCumeSdSGof08pA_3Ft2Tw5SHbIiPAfr_ToQXaFmYMeta } from "/app/apps/web/app/pages/app/runs/[id].vue?macro=true";
import { default as _91shareId_93jXX3gT_IDKakVxU3_6jK3yA2odQ9uaMKGD5R8_g9LZcMeta } from "/app/apps/web/app/pages/app/shared/[shareId].vue?macro=true";
import { default as _91id_93tZYZBTPSP2_pxgGaXIxI8l1pEvpqr4ejKyBDugN0RWQMeta } from "/app/apps/web/app/pages/app/sheets/[id].vue?macro=true";
import { default as runawvB_Ly91_vKR2k8jFMo1DKSUUxtzeowJSkQYmXCPEAMeta } from "/app/apps/web/app/pages/app/workflows/[id]/run.vue?macro=true";
import { default as indexoJ6D8EMKrZHpftP_4JvTxfs43w8aPyFq0fqLEgf_ne0Meta } from "/app/apps/web/app/pages/app/workflows/[id]/index.vue?macro=true";
import { default as _91id_93u8CI_ZLv4LlHydwCLuWul3ktl19V9ebS3hqwUs7hgQcMeta } from "/app/apps/web/app/pages/app/workflows/[id].vue?macro=true";
import { default as membersJ_kDK0G56bSekePoDLfASXOUnXloZa7bokdU9dspubAMeta } from "/app/apps/web/app/pages/app/admin/organizations/[id]/members.vue?macro=true";
import { default as index6G_Wqyua1gGUmEW_HeKEa3Jm1isR6vBVkQaLtW63faIMeta } from "/app/apps/web/app/pages/app/admin/organizations/[id]/index.vue?macro=true";
import { default as indexz2ADFR2Vbjqf3M8ZTTK3r1cA3vCnb_nR2G2BnlWLxRAMeta } from "/app/apps/web/app/pages/app/admin/contract-review-types/index.vue?macro=true";
import { default as document_45templatesLZACCz9oyPG_XeUmPV_2IPPSsThhNQUbIxm_Ic5RYaIMeta } from "/app/apps/web/app/pages/app/admin/document-templates.vue?macro=true";
import { default as ingest_45costsEZ_ZHmfoDv2_rWiNALVIJ9a6N7JuvKnsCdKiXTGaIhUMeta } from "/app/apps/web/app/pages/app/admin/ingest-costs.vue?macro=true";
import { default as mcp_8zvX6f0v535KMhU9GFYxJYcgzHlEiFTxBMxZ36v7bsMeta } from "/app/apps/web/app/pages/app/admin/mcp.vue?macro=true";
import { default as missing_45aliasesmZwkzORSe_IWgckAldcXBw_uMnpPafd7SDpOUH6rY3IMeta } from "/app/apps/web/app/pages/app/admin/missing-aliases.vue?macro=true";
import { default as indexhviZGbSp1iny3uurzPaYQ_yXCMvK5X0zuV_J6hQW_44Meta } from "/app/apps/web/app/pages/app/admin/organizations/index.vue?macro=true";
import { default as planszl8BamvDX6Hhq76zXuiwGy4CsYMwBUE5aBAsjgWetksMeta } from "/app/apps/web/app/pages/app/admin/plans.vue?macro=true";
import { default as public_45researchnjPk4CtZojbCj3BLeTiwdC85qNsXrOweM4QfD1Z2E8YMeta } from "/app/apps/web/app/pages/app/admin/public-research.vue?macro=true";
import { default as rag_45playgroundiCsUUV8Bh1vdxZjAGWU6NnCf06f35_ov9BW63W9REx8Meta } from "/app/apps/web/app/pages/app/admin/rag-playground.vue?macro=true";
import { default as service_45healthBZaPVs1zDvc3ZmQgKRamUA_uv_kqcXXCjSXcFg_S_uMMeta } from "/app/apps/web/app/pages/app/admin/service-health.vue?macro=true";
import { default as thumbnail_45backfillllSI93g_D3pziYmdekaZG702kkIJbv5M_yNNwz_nZO0Meta } from "/app/apps/web/app/pages/app/admin/thumbnail-backfill.vue?macro=true";
import { default as token_45usageGyw2ZrCWtce_QP8fxwen3EXRjZX_8vyn7Al6_jKbpL8Meta } from "/app/apps/web/app/pages/app/admin/token-usage.vue?macro=true";
import { default as vouchersTquK3q2dZ5THMowMG7_SzJ31GTCV5INpeOIo6SPUNNEMeta } from "/app/apps/web/app/pages/app/admin/vouchers.vue?macro=true";
import { default as indexXdRbbLVJVeHTjuWu6ErJ9KsPzrslZeMN2bd4p9jUYJoMeta } from "/app/apps/web/app/pages/app/admin/index.vue?macro=true";
import { default as adminOJzOfMZauTCGLa3tovKG9onXsU2DzkK2PrSQRHy4jNUMeta } from "/app/apps/web/app/pages/app/admin.vue?macro=true";
import { default as agentiDsruTe62vKkaxdzbxU1PZURcLS8HJsr7xx6FyYKhWUMeta } from "/app/apps/web/app/pages/app/agent.vue?macro=true";
import { default as indexwrylsqYDtJ1Z_G_QcTmB05xc0VlaGU4YzALYo2ynTn4Meta } from "/app/apps/web/app/pages/app/briefs/index.vue?macro=true";
import { default as index9RBxRwMsQZMPIvl2oePWlqrPlNOdxXCTOZ1d0SQyhG0Meta } from "/app/apps/web/app/pages/app/cases/index.vue?macro=true";
import { default as index3kVC4_aOlvlDDxU0abLNguKzVDZJlqNzzIUfjCXHT8gMeta } from "/app/apps/web/app/pages/app/clients/index.vue?macro=true";
import { default as indexfbeDDkIe5aS6AcqMJBxUbV5dkaKndUplBWcLvRWugHMMeta } from "/app/apps/web/app/pages/app/contract-review/index.vue?macro=true";
import { default as indexEV7RJTJ00lOwU1EmXcOEj7V9PIM586GhnfECquyXZHEMeta } from "/app/apps/web/app/pages/app/docs/index.vue?macro=true";
import { default as guidance89Hb__Vtn5JH4DXwz5PGKZQwndwyCPPPsgOPUEzD6fsMeta } from "/app/apps/web/app/pages/app/guidance.vue?macro=true";
import { default as historyUAMiqBBskUeO2IFpI__wcGcirtFy8CWf1mHpPGSEeZsMeta } from "/app/apps/web/app/pages/app/history.vue?macro=true";
import { default as index5HznHUhuAXCUzO8bnr_yP8WkewGcnQEUQlPBdzkSK6IMeta } from "/app/apps/web/app/pages/app/laws/index.vue?macro=true";
import { default as libraryO61M5dyOojrYbx8W_X4Gd0ZFz7b_V4cDK6Gn0uevwusMeta } from "/app/apps/web/app/pages/app/library.vue?macro=true";
import { default as indexDo8_kSs68eu663TYOWkq8FbzBIIcHWz2MSDFiVluerkMeta } from "/app/apps/web/app/pages/app/runs/index.vue?macro=true";
import { default as membersEsA8zfDm3bKgwGTKHU7d5O0teM43bQnzMlUz_fC7eXAMeta } from "/app/apps/web/app/pages/app/settings/organization/members.vue?macro=true";
import { default as roles__1OEKF525HHQQ1ezE0QLmWTNqyqEHLB_F_zcABDMToMeta } from "/app/apps/web/app/pages/app/settings/organization/roles.vue?macro=true";
import { default as appearancebCzCOtTUGc6_RAPs5IO5eYdpI5eTPwFVMJHjk3q7tRQMeta } from "/app/apps/web/app/pages/app/settings/appearance.vue?macro=true";
import { default as audit_45logAgoJ5HXSUNK9CwWUoJHaUgyy2u3a8fgQSldFcKUxKI8Meta } from "/app/apps/web/app/pages/app/settings/audit-log.vue?macro=true";
import { default as billingE6L15dbnhKD9pYQPM2RhWpiB5_wFtD_QGQuqdV0jdfIMeta } from "/app/apps/web/app/pages/app/settings/billing.vue?macro=true";
import { default as document_45templatestO7f_Q_ZgQOAjdhbKVLG6iSj8b4yvfGroK1CIzaDrCcMeta } from "/app/apps/web/app/pages/app/settings/document-templates.vue?macro=true";
import { default as languagekV36ortgABN1AjrhSFOse1D2ma4s3YgUKJzBCzd7xpwMeta } from "/app/apps/web/app/pages/app/settings/language.vue?macro=true";
import { default as logoutj1R5GM9BErvuU8nhZm6QSrFO99greOnaLwGcO0GV6p0Meta } from "/app/apps/web/app/pages/app/settings/logout.vue?macro=true";
import { default as mcpqQG8_E_9k48cIGCOL1Kynb4Ml88iD8zsE1PoWClFQbcMeta } from "/app/apps/web/app/pages/app/settings/mcp.vue?macro=true";
import { default as indexj7WKsIVpSBeUjJVts5ABwqBtXpmuFjm6XS5otHdA8lUMeta } from "/app/apps/web/app/pages/app/settings/organization/index.vue?macro=true";
import { default as passwordIj9dvQhnt9IgHXEHBa7Y5nHyXEZAXTo2gfJC6lK0KKcMeta } from "/app/apps/web/app/pages/app/settings/password.vue?macro=true";
import { default as playbooksVqGPhTH1BUQkHLtcEwzVAOHJ6iyfYQvDNvmc0ECI9UMMeta } from "/app/apps/web/app/pages/app/settings/playbooks.vue?macro=true";
import { default as privacyxPz8wg0q6fCEyhukzwzRARUp7d7kWTjJETMK5F9Hs58Meta } from "/app/apps/web/app/pages/app/settings/privacy.vue?macro=true";
import { default as profile2vyFEhIRI5uBhzxvIAO_X8KUev3Dj_7TiKe_nsw4qC4Meta } from "/app/apps/web/app/pages/app/settings/profile.vue?macro=true";
import { default as rules7jCksgJgy_IE0E_SF_6auYH7JLovbdeNX_yfqKHeeJ4Meta } from "/app/apps/web/app/pages/app/settings/rules.vue?macro=true";
import { default as securityrgxJWIAzcGiF50c_vTehHoWoq_0y5KkpPK0K83Cj6K4Meta } from "/app/apps/web/app/pages/app/settings/security.vue?macro=true";
import { default as templates2VQOLdKTBwjV72Edz7d_CEhSYiYOKWEcJhwP2h8Nl1MMeta } from "/app/apps/web/app/pages/app/settings/templates.vue?macro=true";
import { default as usageW2LzCovnCbws9SwPX_DKVUYdmE2dFO2G_8Boj6iBBSIMeta } from "/app/apps/web/app/pages/app/settings/usage.vue?macro=true";
import { default as word_45addinM2_Vu5EmCiNF0eQcE_jwhDR5NjyjqYBRVCCThCq6GTEMeta } from "/app/apps/web/app/pages/app/settings/word-addin.vue?macro=true";
import { default as settingspoiY3Xxhc6V7cBOr4QTzRsNajhJK0fV8XXU_k372QBAMeta } from "/app/apps/web/app/pages/app/settings.vue?macro=true";
import { default as setupd4uLCa0XJ1aiFdY_4E_FMDoGF5hJO63clbBW4l1NHlAMeta } from "/app/apps/web/app/pages/app/setup.vue?macro=true";
import { default as indexRSdSL0OlJPY5sfmflTvn4mdMKSwdwHq2OPKa3oPhshoMeta } from "/app/apps/web/app/pages/app/sheets/index.vue?macro=true";
import { default as indexVVJhc_hGuiUO11AodLVEa3S1rzsZxrAT5lXdBxX55mcMeta } from "/app/apps/web/app/pages/app/workflows/index.vue?macro=true";
import { default as index9UyrP7FJPVy4_CLgmaX6nV1gbzaCQ3vdHwprhnkV49YMeta } from "/app/apps/web/app/pages/app/index.vue?macro=true";
import { default as appiAqbCwHn6NuK_9L3IhqR8wx6uPeMaitSkx4jtMyI9yMMeta } from "/app/apps/web/app/pages/app.vue?macro=true";
import { default as indexCm9PVqdQl9Qn5KnhIhzk9bWevmFebfSIivzyPIl2qIoMeta } from "/app/apps/web/app/pages/blog/index.vue?macro=true";
import { default as chatOw_SxZH_fzE20W94ZMiuvRGCvf0bCDIi0a3ZPcAI9N0Meta } from "/app/apps/web/app/pages/chat.vue?macro=true";
import { default as login3DE2BnCir6mvf8_x52R_de3tWrGI1iIe4exSoRIkACsMeta } from "/app/apps/web/app/pages/login.vue?macro=true";
import { default as pago_45simulado7ZEvUo7QqzhP0J_7l5MCJTKS0nuDlqjcVJIqdYuG8PIMeta } from "/app/apps/web/app/pages/pago-simulado.vue?macro=true";
import { default as pago_45simulado_45campos_uPUHn7fCfeOSvFf_lWdQEhoGr63_gGBT3fGY5J5a_QMeta } from "/app/apps/web/app/pages/pago-simulado-campos.vue?macro=true";
import { default as privacidadDf4a82HtAWVV1v6dCHy2ri2wLKVPVtdB6xMfjultiTIMeta } from "/app/apps/web/app/pages/privacidad.vue?macro=true";
import { default as seguridadZ4_jozvhX8t6jBNx_cXL934zFpNJ5qUH5ejz_UlG7hIMeta } from "/app/apps/web/app/pages/seguridad.vue?macro=true";
import { default as terminosI4JCGj_Bq60u6UBCLMFfRhIk20233djzGWRuuVJPQrkMeta } from "/app/apps/web/app/pages/terminos.vue?macro=true";
import { default as indexOD5qQIZWPjSLQfLiP_xQido16k5ZUKGQVaC0fYIPlvwMeta } from "/app/apps/web/app/pages/index.vue?macro=true";
import { default as component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta } from "/app/node_modules/.pnpm/nuxt@4.5.1_d229e40015be0471a0521c4a5e460bd9/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw } from "/app/node_modules/.pnpm/nuxt@4.5.1_d229e40015be0471a0521c4a5e460bd9/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93saOIxIFMGHXnmHQoD_g_aDWuF17P58DBuvovIMpC8uUMeta || {},
    component: () => import("/app/apps/web/app/pages/blog/[slug].vue")
  },
  {
    name: "addin",
    path: "/addin",
    meta: addinK5YZdkrxglfYUu0_oqlTIrTy10WK_bo1iPcMnpArVa0Meta || {},
    component: () => import("/app/apps/web/app/pages/addin.vue")
  },
  {
    name: appiAqbCwHn6NuK_9L3IhqR8wx6uPeMaitSkx4jtMyI9yMMeta?.name,
    path: "/app",
    component: () => import("/app/apps/web/app/pages/app.vue"),
    children: [
  {
    name: "app-briefs-case-id",
    path: "briefs/case/:id()",
    component: () => import("/app/apps/web/app/pages/app/briefs/case/[id].vue")
  },
  {
    name: "app-briefs-parties-id",
    path: "briefs/parties/:id()",
    component: () => import("/app/apps/web/app/pages/app/briefs/parties/[id].vue")
  },
  {
    name: "app-laws-id-id",
    path: "laws/id/:id()",
    meta: _91id_93_UtH3CXDVcISWoLefzQZwMMkTyhNJjRLDC4JVI9_lQEMeta || {},
    component: () => import("/app/apps/web/app/pages/app/laws/id/[id].vue")
  },
  {
    name: "app-cases-new",
    path: "cases/new",
    component: () => import("/app/apps/web/app/pages/app/cases/new.vue")
  },
  {
    name: "app-clients-new",
    path: "clients/new",
    component: () => import("/app/apps/web/app/pages/app/clients/new.vue")
  },
  {
    name: "app-clients-parties",
    path: "clients/parties",
    component: () => import("/app/apps/web/app/pages/app/clients/parties.vue")
  },
  {
    name: "app-docs-trash",
    path: "docs/trash",
    component: () => import("/app/apps/web/app/pages/app/docs/trash.vue")
  },
  {
    name: "app-cases-id-notes-new",
    path: "cases/:id()/notes/new",
    component: () => import("/app/apps/web/app/pages/app/cases/[id]/notes/new.vue")
  },
  {
    name: "app-cases-id-tasks-new",
    path: "cases/:id()/tasks/new",
    component: () => import("/app/apps/web/app/pages/app/cases/[id]/tasks/new.vue")
  },
  {
    name: "app-cases-id-workflow-workflowId",
    path: "cases/:id()/workflow/:workflowId()",
    component: () => import("/app/apps/web/app/pages/app/cases/[id]/workflow/[workflowId].vue")
  },
  {
    name: "app-clients-id-workflow-workflowId",
    path: "clients/:id()/workflow/:workflowId()",
    component: () => import("/app/apps/web/app/pages/app/clients/[id]/workflow/[workflowId].vue")
  },
  {
    name: "app-cases-id-documents",
    path: "cases/:id()/documents",
    component: () => import("/app/apps/web/app/pages/app/cases/[id]/documents.vue")
  },
  {
    name: "app-cases-id-personeria",
    path: "cases/:id()/personeria",
    component: () => import("/app/apps/web/app/pages/app/cases/[id]/personeria.vue")
  },
  {
    name: "app-clients-id-personeria",
    path: "clients/:id()/personeria",
    component: () => import("/app/apps/web/app/pages/app/clients/[id]/personeria.vue")
  },
  {
    name: "app-briefs-type",
    path: "briefs/:type()",
    component: () => import("/app/apps/web/app/pages/app/briefs/[type].vue")
  },
  {
    name: "app-c-id",
    path: "c/:id()",
    component: () => import("/app/apps/web/app/pages/app/c/[id].vue")
  },
  {
    name: "app-cases-id",
    path: "cases/:id()",
    component: () => import("/app/apps/web/app/pages/app/cases/[id]/index.vue")
  },
  {
    name: "app-clients-id",
    path: "clients/:id()",
    component: () => import("/app/apps/web/app/pages/app/clients/[id]/index.vue")
  },
  {
    name: "app-contract-review-id",
    path: "contract-review/:id()",
    component: () => import("/app/apps/web/app/pages/app/contract-review/[id].vue")
  },
  {
    name: "app-docs-id",
    path: "docs/:id()",
    component: () => import("/app/apps/web/app/pages/app/docs/[id].vue")
  },
  {
    name: "app-runs-id",
    path: "runs/:id()",
    component: () => import("/app/apps/web/app/pages/app/runs/[id].vue")
  },
  {
    name: "app-shared-shareId",
    path: "shared/:shareId()",
    component: () => import("/app/apps/web/app/pages/app/shared/[shareId].vue")
  },
  {
    name: "app-sheets-id",
    path: "sheets/:id()",
    component: () => import("/app/apps/web/app/pages/app/sheets/[id].vue")
  },
  {
    name: _91id_93u8CI_ZLv4LlHydwCLuWul3ktl19V9ebS3hqwUs7hgQcMeta?.name,
    path: "workflows/:id()",
    component: () => import("/app/apps/web/app/pages/app/workflows/[id].vue"),
    children: [
  {
    name: "app-workflows-id-run",
    path: "run",
    component: () => import("/app/apps/web/app/pages/app/workflows/[id]/run.vue")
  },
  {
    name: "app-workflows-id",
    path: "",
    component: () => import("/app/apps/web/app/pages/app/workflows/[id]/index.vue")
  }
]
  },
  {
    name: adminOJzOfMZauTCGLa3tovKG9onXsU2DzkK2PrSQRHy4jNUMeta?.name,
    path: "admin",
    meta: {"middleware":["super-admin"]},
    component: () => import("/app/apps/web/app/pages/app/admin.vue"),
    children: [
  {
    name: "app-admin-organizations-id-members",
    path: "organizations/:id()/members",
    component: () => import("/app/apps/web/app/pages/app/admin/organizations/[id]/members.vue")
  },
  {
    name: "app-admin-organizations-id",
    path: "organizations/:id()",
    component: () => import("/app/apps/web/app/pages/app/admin/organizations/[id]/index.vue")
  },
  {
    name: "app-admin-contract-review-types",
    path: "contract-review-types",
    component: () => import("/app/apps/web/app/pages/app/admin/contract-review-types/index.vue")
  },
  {
    name: "app-admin-document-templates",
    path: "document-templates",
    component: () => import("/app/apps/web/app/pages/app/admin/document-templates.vue")
  },
  {
    name: "app-admin-ingest-costs",
    path: "ingest-costs",
    component: () => import("/app/apps/web/app/pages/app/admin/ingest-costs.vue")
  },
  {
    name: "app-admin-mcp",
    path: "mcp",
    component: () => import("/app/apps/web/app/pages/app/admin/mcp.vue")
  },
  {
    name: "app-admin-missing-aliases",
    path: "missing-aliases",
    component: () => import("/app/apps/web/app/pages/app/admin/missing-aliases.vue")
  },
  {
    name: "app-admin-organizations",
    path: "organizations",
    component: () => import("/app/apps/web/app/pages/app/admin/organizations/index.vue")
  },
  {
    name: "app-admin-plans",
    path: "plans",
    meta: {"middleware":["super-admin"]},
    component: () => import("/app/apps/web/app/pages/app/admin/plans.vue")
  },
  {
    name: "app-admin-public-research",
    path: "public-research",
    component: () => import("/app/apps/web/app/pages/app/admin/public-research.vue")
  },
  {
    name: "app-admin-rag-playground",
    path: "rag-playground",
    component: () => import("/app/apps/web/app/pages/app/admin/rag-playground.vue")
  },
  {
    name: "app-admin-service-health",
    path: "service-health",
    component: () => import("/app/apps/web/app/pages/app/admin/service-health.vue")
  },
  {
    name: "app-admin-thumbnail-backfill",
    path: "thumbnail-backfill",
    component: () => import("/app/apps/web/app/pages/app/admin/thumbnail-backfill.vue")
  },
  {
    name: "app-admin-token-usage",
    path: "token-usage",
    component: () => import("/app/apps/web/app/pages/app/admin/token-usage.vue")
  },
  {
    name: "app-admin-vouchers",
    path: "vouchers",
    component: () => import("/app/apps/web/app/pages/app/admin/vouchers.vue")
  },
  {
    name: "app-admin",
    path: "",
    component: () => import("/app/apps/web/app/pages/app/admin/index.vue")
  }
]
  },
  {
    name: "app-agent",
    path: "agent",
    component: () => import("/app/apps/web/app/pages/app/agent.vue")
  },
  {
    name: "app-briefs",
    path: "briefs",
    component: () => import("/app/apps/web/app/pages/app/briefs/index.vue")
  },
  {
    name: "app-cases",
    path: "cases",
    component: () => import("/app/apps/web/app/pages/app/cases/index.vue")
  },
  {
    name: "app-clients",
    path: "clients",
    component: () => import("/app/apps/web/app/pages/app/clients/index.vue")
  },
  {
    name: "app-contract-review",
    path: "contract-review",
    component: () => import("/app/apps/web/app/pages/app/contract-review/index.vue")
  },
  {
    name: "app-docs",
    path: "docs",
    component: () => import("/app/apps/web/app/pages/app/docs/index.vue")
  },
  {
    name: "app-guidance",
    path: "guidance",
    component: () => import("/app/apps/web/app/pages/app/guidance.vue")
  },
  {
    name: "app-history",
    path: "history",
    component: () => import("/app/apps/web/app/pages/app/history.vue")
  },
  {
    name: "app-laws",
    path: "laws",
    meta: index5HznHUhuAXCUzO8bnr_yP8WkewGcnQEUQlPBdzkSK6IMeta || {},
    component: () => import("/app/apps/web/app/pages/app/laws/index.vue")
  },
  {
    name: "app-library",
    path: "library",
    component: () => import("/app/apps/web/app/pages/app/library.vue")
  },
  {
    name: "app-runs",
    path: "runs",
    component: () => import("/app/apps/web/app/pages/app/runs/index.vue")
  },
  {
    name: "app-settings",
    path: "settings",
    meta: settingspoiY3Xxhc6V7cBOr4QTzRsNajhJK0fV8XXU_k372QBAMeta || {},
    component: () => import("/app/apps/web/app/pages/app/settings.vue"),
    children: [
  {
    name: "app-settings-organization-members",
    path: "organization/members",
    component: () => import("/app/apps/web/app/pages/app/settings/organization/members.vue")
  },
  {
    name: "app-settings-organization-roles",
    path: "organization/roles",
    component: () => import("/app/apps/web/app/pages/app/settings/organization/roles.vue")
  },
  {
    name: "app-settings-appearance",
    path: "appearance",
    component: () => import("/app/apps/web/app/pages/app/settings/appearance.vue")
  },
  {
    name: "app-settings-audit-log",
    path: "audit-log",
    component: () => import("/app/apps/web/app/pages/app/settings/audit-log.vue")
  },
  {
    name: "app-settings-billing",
    path: "billing",
    component: () => import("/app/apps/web/app/pages/app/settings/billing.vue")
  },
  {
    name: "app-settings-document-templates",
    path: "document-templates",
    component: () => import("/app/apps/web/app/pages/app/settings/document-templates.vue")
  },
  {
    name: "app-settings-language",
    path: "language",
    component: () => import("/app/apps/web/app/pages/app/settings/language.vue")
  },
  {
    name: "app-settings-logout",
    path: "logout",
    component: () => import("/app/apps/web/app/pages/app/settings/logout.vue")
  },
  {
    name: "app-settings-mcp",
    path: "mcp",
    component: () => import("/app/apps/web/app/pages/app/settings/mcp.vue")
  },
  {
    name: "app-settings-organization",
    path: "organization",
    component: () => import("/app/apps/web/app/pages/app/settings/organization/index.vue")
  },
  {
    name: "app-settings-password",
    path: "password",
    component: () => import("/app/apps/web/app/pages/app/settings/password.vue")
  },
  {
    name: "app-settings-playbooks",
    path: "playbooks",
    component: () => import("/app/apps/web/app/pages/app/settings/playbooks.vue")
  },
  {
    name: "app-settings-privacy",
    path: "privacy",
    component: () => import("/app/apps/web/app/pages/app/settings/privacy.vue")
  },
  {
    name: "app-settings-profile",
    path: "profile",
    component: () => import("/app/apps/web/app/pages/app/settings/profile.vue")
  },
  {
    name: "app-settings-rules",
    path: "rules",
    component: () => import("/app/apps/web/app/pages/app/settings/rules.vue")
  },
  {
    name: "app-settings-security",
    path: "security",
    component: () => import("/app/apps/web/app/pages/app/settings/security.vue")
  },
  {
    name: "app-settings-templates",
    path: "templates",
    component: () => import("/app/apps/web/app/pages/app/settings/templates.vue")
  },
  {
    name: "app-settings-usage",
    path: "usage",
    component: () => import("/app/apps/web/app/pages/app/settings/usage.vue")
  },
  {
    name: "app-settings-word-addin",
    path: "word-addin",
    component: () => import("/app/apps/web/app/pages/app/settings/word-addin.vue")
  }
]
  },
  {
    name: "app-setup",
    path: "setup",
    meta: setupd4uLCa0XJ1aiFdY_4E_FMDoGF5hJO63clbBW4l1NHlAMeta || {},
    component: () => import("/app/apps/web/app/pages/app/setup.vue")
  },
  {
    name: "app-sheets",
    path: "sheets",
    component: () => import("/app/apps/web/app/pages/app/sheets/index.vue")
  },
  {
    name: "app-workflows",
    path: "workflows",
    component: () => import("/app/apps/web/app/pages/app/workflows/index.vue")
  },
  {
    name: "app",
    path: "",
    component: () => import("/app/apps/web/app/pages/app/index.vue")
  },
  {
    name: "app-laws-browse",
    path: "laws/browse/:type/:year(\\d+)?/:month(\\d+)?",
    meta: index5HznHUhuAXCUzO8bnr_yP8WkewGcnQEUQlPBdzkSK6IMeta || {},
    component: () => import("/app/apps/web/app/pages/app/laws/index.vue")
  },
  {
    name: "app-laws-browse-detail",
    path: "/app/laws/browse/:type/:year(\\d+)?/:month(\\d+)?/:id([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})",
    meta: _91id_93_UtH3CXDVcISWoLefzQZwMMkTyhNJjRLDC4JVI9_lQEMeta || {},
    component: () => import("/app/apps/web/app/pages/app/laws/id/[id].vue")
  }
]
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexCm9PVqdQl9Qn5KnhIhzk9bWevmFebfSIivzyPIl2qIoMeta || {},
    component: () => import("/app/apps/web/app/pages/blog/index.vue")
  },
  {
    name: "chat",
    path: "/chat",
    meta: chatOw_SxZH_fzE20W94ZMiuvRGCvf0bCDIi0a3ZPcAI9N0Meta || {},
    component: () => import("/app/apps/web/app/pages/chat.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login3DE2BnCir6mvf8_x52R_de3tWrGI1iIe4exSoRIkACsMeta || {},
    component: () => import("/app/apps/web/app/pages/login.vue")
  },
  {
    name: "pago-simulado",
    path: "/pago-simulado",
    meta: pago_45simulado7ZEvUo7QqzhP0J_7l5MCJTKS0nuDlqjcVJIqdYuG8PIMeta || {},
    component: () => import("/app/apps/web/app/pages/pago-simulado.vue")
  },
  {
    name: "pago-simulado-campos",
    path: "/pago-simulado-campos",
    meta: pago_45simulado_45campos_uPUHn7fCfeOSvFf_lWdQEhoGr63_gGBT3fGY5J5a_QMeta || {},
    component: () => import("/app/apps/web/app/pages/pago-simulado-campos.vue")
  },
  {
    name: "privacidad",
    path: "/privacidad",
    meta: privacidadDf4a82HtAWVV1v6dCHy2ri2wLKVPVtdB6xMfjultiTIMeta || {},
    component: () => import("/app/apps/web/app/pages/privacidad.vue")
  },
  {
    name: "seguridad",
    path: "/seguridad",
    meta: seguridadZ4_jozvhX8t6jBNx_cXL934zFpNJ5qUH5ejz_UlG7hIMeta || {},
    component: () => import("/app/apps/web/app/pages/seguridad.vue")
  },
  {
    name: "terminos",
    path: "/terminos",
    meta: terminosI4JCGj_Bq60u6UBCLMFfRhIk20233djzGWRuuVJPQrkMeta || {},
    component: () => import("/app/apps/web/app/pages/terminos.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexOD5qQIZWPjSLQfLiP_xQido16k5ZUKGQVaC0fYIPlvwMeta || {},
    component: () => import("/app/apps/web/app/pages/index.vue")
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/landing-new",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/research",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/projects",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/projects/:pathMatch(.*)",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/clients/matters",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/clients/matters/:pathMatch(.*)",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/briefs/matter/:pathMatch(.*)",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/clients/cases",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  },
  {
    name: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggwMeta?.name,
    path: "/app/clients/cases/:pathMatch(.*)",
    component: component_45stubPs4i8BRFeVZSg66Ao8jHiJxPmg2LPM43R6eUPT_2ggw
  }
]